<template>
  <div class="account-sub-menu">
    <ul class="account-sub-menu__list">
      <li
        v-for="tier1 in desktopAccount"
        :key="tier1.handle"
        class="account-sub-menu__item body-2"
      >
        <a
          :href="tier1.url"
          class="account-sub-menu__link"
          v-text="tier1.title"
        />
      </li>
      <li class="account-sub-menu__item body-2">
        <a
          :href="logoutUrl"
          class="account-sub-menu__link"
          v-text="$string('general.site_header.logout')"
        />
      </li>
    </ul>
  </div>
</template>

<script>


/**
 * Vue: account-sub-menu (account-sub-menu)
 * -----------------------------------------------------------------------------
 * This is sub-menu dropdown for my account header link.
 *
 */
export default {
  name: 'AccountSubMenu',

  props: {
    desktopAccount: {
      type: Array,
      default: () => [],
    },
    logoutUrl: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      global: true,
    }
  },
}
</script>